import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=ffd0464c&scoped=true"
import script from "./Offline.js?vue&type=script&lang=js&external"
export * from "./Offline.js?vue&type=script&lang=js&external"
import style0 from "./Offline.scss?vue&type=style&index=0&id=ffd0464c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd0464c",
  null
  
)

export default component.exports